"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _domAlign = _interopRequireDefault(require("dom-align"));

var _rafThrottle = _interopRequireDefault(require("raf-throttle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var DomAlign =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DomAlign, _React$Component);

  function DomAlign() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, DomAlign);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = DomAlign.__proto__ || Object.getPrototypeOf(DomAlign)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "state", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: {
        source: undefined
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "onSourceRef", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(source) {
        _this.setState({
          source: source
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "timeoutId", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    }), Object.defineProperty(_assertThisInitialized(_this), "align", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: (0, _rafThrottle.default)(function () {
        var _this$props = _this.props,
            target = _this$props.target,
            config = _this$props.config;
        var source = _this.state.source;

        if (target && source) {
          // Note: Wait for two react instance ready.
          (0, _domAlign.default)((0, _reactDom.findDOMNode)(source), (0, _reactDom.findDOMNode)(target), config);
        }
      })
    }), _temp));
  }

  _createClass(DomAlign, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.align();

      if (this.props.resize) {
        window.addEventListener('resize', this.align);
        window.addEventListener('scroll', this.align);
        window.addEventListener('wheel', this.align);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      // TODO: make it async. there is a problem of overlay in dialog case.
      this.timeoutId = setTimeout(function () {
        return _this2.align();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.resize) {
        window.removeEventListener('resize', this.align);
        window.removeEventListener('scroll', this.align);
        window.removeEventListener('wheel', this.align);
      }

      if (this.align && this.align.cancel) this.align.cancel();
      if (this.timeoutId) clearTimeout(this.timeoutId);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var onSourceRef = this.onSourceRef;
      return React.cloneElement(React.Children.only(children), {
        ref: onSourceRef
      });
    }
  }]);

  return DomAlign;
}(React.Component);

Object.defineProperty(DomAlign, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    target: undefined,
    resize: false
  }
});
var _default = DomAlign;
exports.default = _default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-overlay-pack/lib/DomAlign/DomAlign.js
// module id = 539
// module chunks = 4